import toast from "react-hot-toast";

class AgencyAPIs {
    static async list({ axiosPrivate, status, is_deleted = false, limit = 20, offset = 0 }) {
        try {
            const params = new URLSearchParams({
                is_deleted: String(is_deleted),
                ...(status && { status }),
                ...(limit != null && { limit }),
                ...(offset != null && { offset }),
            });
            const url = `/api/v1/agency/?${params.toString()}`;
            const response = await axiosPrivate.get(url);
            const list = response?.data?.data ?? response?.data ?? [];
            const count = response?.data?.count ?? list?.length ?? 0;
            return { data: Array.isArray(list) ? list : [], count };
        } catch (error) {
            const status = error?.response?.status;
            // Listing agencies requires agency.manage; missing permission is expected for many roles — do not toast.
            if (status !== 403 && status !== 401) {
                toast.error(error?.response?.data?.error_message || error?.message);
            }
            return { data: [], count: 0 };
        }
    }

    static async create({ axiosPrivate, payload }) {
        try {
            const url = `/api/v1/agency/`;
            const response = await axiosPrivate.post(url, payload);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async update({ axiosPrivate, id, payload }) {
        try {
            const url = `/api/v1/agency/${id}/`;
            const response = await axiosPrivate.patch(url, payload);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async retrieve({ axiosPrivate, id }) {
        try {
            const url = `/api/v1/agency/${id}/`;
            const response = await axiosPrivate.get(url);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
        }
    }
}

export default AgencyAPIs;
